import { useVoteSeller } from '@/lib/hooks';
import Button from '../button';

import type { FunctionComponent } from 'react';
import type { TypeVoteButtonProps } from './types';

/**
 * VoteButton
 */
export const VoteButton: FunctionComponent<TypeVoteButtonProps> = ({
  campaign,
  category,
  seller,
}: TypeVoteButtonProps) => {
  const [voteSeller, { loading, isCategoryVoted, isSellerVoted }] =
    useVoteSeller();

  const sellerVoted = isSellerVoted({ category, seller });
  const categoryVoted = isCategoryVoted({ category });

  const label = sellerVoted
    ? 'VOTADO'
    : categoryVoted
      ? 'NO SELECCIONADO'
      : 'VOTAR';

  return (
    <Button
      variant="tertiary"
      as="button"
      type="button"
      className="!text-bg-secondary"
      disabled={categoryVoted && !sellerVoted}
      loading={loading}
      {...(!sellerVoted &&
        !categoryVoted &&
        !loading && {
          onClick: async () => {
            await voteSeller({
              campaign,
              category,
              seller,
            });
          },
        })}
    >
      {label}
    </Button>
  );
};

VoteButton.displayName = 'VoteButton';
